import { render, staticRenderFns } from "./OrderDetailsModalComponent.vue?vue&type=template&id=01e50735&scoped=true&"
import script from "./OrderDetailsModalComponent.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsModalComponent.vue?vue&type=style&index=0&id=01e50735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e50735",
  null
  
)

export default component.exports